/**
 * Tenant Logo Registry
 *
 * Maps tenant slugs to their custom logo components.
 * Fall back to default XeVoicePro logo when no custom logo exists.
 */

import { EliteLogo, EliteLogoIcon } from './EliteLogo';
import { SublimeCareLogo, SublimeCareLogoIcon } from './SublimeCareLogo';

// Registry of tenant-specific logo components
export const TENANT_LOGOS: Record<string, {
  Logo: React.ComponentType<{ size?: 'sm' | 'md' | 'lg'; showText?: boolean; className?: string }>;
  LogoIcon: React.ComponentType<{ size?: 'sm' | 'md' | 'lg'; className?: string }>;
}> = {
  elite: {
    Logo: EliteLogo,
    LogoIcon: EliteLogoIcon,
  },
  sublimecare: {
    Logo: SublimeCareLogo,
    LogoIcon: SublimeCareLogoIcon,
  },
  // Add more tenants here:
  // acme: { Logo: AcmeLogo, LogoIcon: AcmeLogoIcon },
};

/**
 * Get logo component for a tenant
 */
export function getTenantLogo(tenantSlug: string) {
  return TENANT_LOGOS[tenantSlug] || null;
}

/**
 * Check if a tenant has a custom logo
 */
export function hasTenantLogo(tenantSlug: string): boolean {
  return tenantSlug in TENANT_LOGOS;
}

export { EliteLogo, EliteLogoIcon };
export { SublimeCareLogo, SublimeCareLogoIcon };
